import { runtime } from '@/lib/config';
export class CrossApi {
  base = (runtime().clearingApiUrl || 'http://127.0.0.1:8788').replace(/\/$/, '');
  token: string | null = null;
  async call<T = any>(path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
    const r = await fetch(this.base + path, {
      method: init.method || 'GET',
      headers: { ...(init.body ? { 'content-type': 'application/json' } : {}), ...(this.token ? { authorization: `Bearer ${this.token}` } : {}) },
      body: init.body ? JSON.stringify(init.body) : undefined,
      signal: AbortSignal.timeout(15000),
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j?.error?.message || `CROSS API ${r.status}`);
    return j as T;
  }
}
export const api = new CrossApi();
